import { connect } from 'react-redux';

import PresentationComponent from '../../components/dashboards/tabcomponents/TemplateSaving';
import {
  getEvents,
  getEventsGroupColumn,
  getLocation,
  getRetentionComplexFirstEvent,
  getRetentionComplexReturnEvent,
  getUsersColumns,
  getUsersEvent,
} from '../../reducers/analyticsApp';
import { isValidEvent, isValidUsers } from '../../utils/event/common';
import { LOCATION } from '../../constants/location';

const isDisableEvents = (events, groupColumn) =>
  events.some((event) => !isValidEvent(event)) || !groupColumn;

const mapStateToProps = (state) => {
  const location = getLocation(state);

  const getDisabling = () => {
    switch (true) {
      case location.includes(LOCATION.EVENTS): {
        const events = getEvents(state);
        const groupColumn = getEventsGroupColumn(state);

        return isDisableEvents(events, groupColumn);
      }

      case location.includes(LOCATION.USERS): {
        const usersEvent = getUsersEvent(state);
        const usersColumns = getUsersColumns(state);

        return !isValidUsers(usersEvent, usersColumns);
      }

      case location.includes(LOCATION.ADVANCED_RETENTION): {
        const retentionEvents = [
          getRetentionComplexFirstEvent(state),
          getRetentionComplexReturnEvent(state),
        ];

        return !retentionEvents.every((item) => !!item);
      }

      default:
        return false;
    }
  };

  return {
    disabled: getDisabling(),
  };
};

const TemplateSaving = connect(mapStateToProps)(PresentationComponent);

export default TemplateSaving;
